import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, BatteryWarning, BrainCircuit, Scale } from 'lucide-react';
export function PainSection() {
  const symptoms = [{
    icon: <BatteryWarning className="w-8 h-8 text-brand-terracotta" data-id="element-72" />,
    title: 'Fatiga Crónica',
    desc: 'Te despiertas cansada incluso después de dormir 8 horas. Necesitas café para funcionar y azúcar para seguir.'
  }, {
    icon: <BrainCircuit className="w-8 h-8 text-brand-terracotta" data-id="element-73" />,
    title: 'Niebla Mental',
    desc: 'Olvidas palabras comunes en medio de reuniones. Sientes que tu cerebro funciona al 50% de su capacidad.'
  }, {
    icon: <Scale className="w-8 h-8 text-brand-terracotta" data-id="element-74" />,
    title: 'Peso Rebelde',
    desc: "La grasa se acumula en el vientre 'por arte de magia'. Haces dieta, haces ejercicio, pero la báscula no se mueve."
  }, {
    icon: <AlertCircle className="w-8 h-8 text-brand-terracotta" data-id="element-75" />,
    title: 'Ansiedad Súbita',
    desc: 'Te despiertas a las 3 AM con el corazón acelerado. Sientes una irritabilidad que no es propia de ti.'
  }];
  return <section className="py-20 bg-white" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="text-center mb-16" data-id="element-78">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-79">
            ¿Te reconoces en alguna de estas situaciones?
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '100px'
        }} viewport={{
          once: true
        }} className="h-1 bg-brand-gold mx-auto" data-id="element-80"></motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-81">
          {symptoms.map((symptom, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-cream p-8 rounded-xl border border-brand-warm-gray/10 hover:shadow-lg transition-shadow duration-300" data-id="element-82">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mb-6 shadow-sm mx-auto md:mx-0" data-id="element-83">
                {symptom.icon}
              </div>
              <h3 className="font-serif text-xl font-bold text-brand-dark mb-3 text-center md:text-left" data-id="element-84">
                {symptom.title}
              </h3>
              <p className="font-sans text-brand-warm-gray leading-relaxed text-center md:text-left" data-id="element-85">
                {symptom.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-16 text-center max-w-3xl mx-auto" data-id="element-86">
          <p className="font-serif text-2xl text-brand-dark italic" data-id="element-87">
            "Vas al médico y te dice: 'Es el estrés, descansa más' o peor... 'Ya
            tienes una edad, es normal'."
          </p>
          <p className="font-sans font-bold text-brand-terracotta text-xl mt-4" data-id="element-88">
            MENTIRA. NO ES NORMAL.
          </p>
        </motion.div>
      </div>
    </section>;
}